
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11408",
                "data-name": "矩形 11408",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.5 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_346",
        "data-name": "蒙版组 346",
        "class": "cls-2",
        "transform": "translate(0.5 0)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "水瓶",
            "class": "cls-3",
            "d": "M280.306,30.6c-.259-4.761-2.747-6.86-3.622-7.457a.893.893,0,0,0,.154-.513v-.893c0-.541-.466-.844-1.066-.844h-1.433c-.6,0-1.149.3-1.149.844v.893a.934.934,0,0,0,.184.494c-.84.57-3.331,2.661-3.593,7.476-.2,3.75-.124,6.632-.063,8.017a1.64,1.64,0,0,0,1.713,1.477H278.7a1.632,1.632,0,0,0,1.706-1.49C280.454,37.224,280.51,34.344,280.306,30.6ZM273.8,21.742c0-.239.276-.3.541-.3h1.433c.264,0,.458.057.458.3V22H273.8Zm0,.8h2.432v.091a.459.459,0,0,1-.458.457h-1.433a.539.539,0,0,1-.541-.457Zm.061.98a1.179,1.179,0,0,0,.48.117h1.433a1.181,1.181,0,0,0,.458-.107,8.258,8.258,0,0,1,3.32,5.731.111.111,0,0,1-.03.094.138.138,0,0,1-.1.042H270.68a.138.138,0,0,1-.1-.042.111.111,0,0,1-.03-.094A8.289,8.289,0,0,1,273.86,23.523ZM270.4,30.631c.011-.2.026-.389.046-.577a.125.125,0,0,1,.129-.105h8.945a.125.125,0,0,1,.129.105c.019.19.035.383.046.583.07,1.282.109,2.459.128,3.511a.178.178,0,0,1-.06.135.22.22,0,0,1-.149.055H270.49a.22.22,0,0,1-.149-.055.178.178,0,0,1-.061-.134C270.3,33.1,270.334,31.915,270.4,30.631Zm9.39,7.958a1.051,1.051,0,0,1-1.1.96h-7.264a1.051,1.051,0,0,1-1.1-.95c-.033-.757-.07-1.967-.062-3.523a.2.2,0,0,1,.21-.19h9.149a.2.2,0,0,1,.21.189q.017,1.757-.045,3.514Z",
            "transform": "translate(-263.05 -17.898)"
          }
        }
      ]
    }
  ]
})
    }
  